// The languages wecare's portal is translated into.
const WECARE_PORTAL_LANGS = new Set(['cs', 'sk', 'pl', 'de', 'it', 'fr', 'es', 'nl', 'da', 'en'])

interface WecareReturnUrlParams {
  orderCode?: string | null
  email?: string | null
}

/**
 * The portal `lang` for a storefront locale's BCP-47 `language`.
 *
 * The portal is keyed by language, not by storefront code: `dk` is written in
 * Danish (`da-DK` → `da`) and `eu` in English (`en`). Languages the portal is
 * not translated into (hu, ro) fall back to English — a TS port of the old
 * WooCommerce plugin's `get_portal_lang()` fallback behaviour.
 */
export function wecarePortalLang(language: string | undefined): string {
  const primary = language?.split('-')[0]?.toLowerCase() ?? ''
  return WECARE_PORTAL_LANGS.has(primary) ? primary : 'en'
}

/**
 * Builds a URL into wecare.exalted.com's returns/claims portal, optionally
 * pre-filled with an order code + email so the customer lands ready to
 * continue (mirrors `build_portal_url()` in the old WooCommerce plugin).
 */
export function useWecarePortal() {
  const localeObject = useLocaleObject()
  const { public: { wecarePortalUrl } } = useRuntimeConfig()

  function buildWecareReturnUrl(params: WecareReturnUrlParams = {}): string {
    if (!wecarePortalUrl)
      return ''

    const url = new URL(wecarePortalUrl)
    url.searchParams.set('lang', wecarePortalLang(localeObject.value?.language))
    if (params.orderCode)
      url.searchParams.set('order_number', params.orderCode)
    if (params.email)
      url.searchParams.set('email', params.email)

    return url.toString()
  }

  return { buildWecareReturnUrl }
}
